import { render, staticRenderFns } from "./DepartmentsManager.vue?vue&type=template&id=6859843e"
import script from "./DepartmentsManager.vue?vue&type=script&lang=js"
export * from "./DepartmentsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports